import * as React from "react";
import { Input, InputProps } from "@mui/material";

// Using TextInput will make sure the `value` prop is of type `string` rather than `unknown`
export interface TextInputProps extends Omit<InputProps, "value"> {
  value: string;
}
const TextInput: React.ComponentType<TextInputProps> = Input;
export default TextInput;
